/**
 * Main entry point for Vite + React Router application
 * Initializes Sentry and mounts the React app with RouterProvider
 */

import './sentry';

import { router } from '@/router';
import { captureException } from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

// Handle Vite preload errors (e.g., when chunks are deleted after deployment)
// This prevents users from seeing import errors when loading outdated chunks
window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    captureException(event.payload, {
        tags: { type: 'vite-preload-error' },
    });
    window.location.reload();
});

// Mount the app
const root = document.getElementById('root');
if (!root) {
    throw new Error('Root element not found');
}

ReactDOM.createRoot(root).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>,
);
